!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.AblyUi = t() : (e.AblyUi = e.AblyUi || {}, e.AblyUi.Core = e.AblyUi.Core || {}, e.AblyUi.Core.Showcase = t());
}(this, () => (() => {
  "use strict";

  var e = {
      d: (t, n) => {
        for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
          enumerable: !0,
          get: n[r]
        });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t)
    },
    t = {};
  e.d(t, {
    default: () => c
  });
  var n = function (e) {
    return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelector("[data-id=".concat(e, "]"));
  };
  function r(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  var o = function (e, t) {
      var n = 100 * t * (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1);
      e.style.transform = "translateX(".concat(n, "%)");
    },
    i = function (e) {
      if ("undefined" == typeof window) return !1;
      var t = "".concat(e + 64, "px");
      return !window.matchMedia("(min-width: ".concat(t, ")")).matches;
    };
  const c = function (e, t) {
    var c = e || n("showcase"),
      u = Array.from(function (e) {
        return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document).querySelectorAll("[data-id=".concat(e, "]"));
      }("showcase-control", c)),
      a = u.map(function (e) {
        return e.querySelector("img");
      }),
      l = n("showcase-controls", c),
      f = n("showcase-index-bar", c),
      s = n("showcase-slides", c),
      d = s.children.length,
      m = ("--ui-showcase-client-logo-min-width", window.getComputedStyle(document.documentElement).getPropertyValue("--ui-showcase-client-logo-min-width")),
      v = parseFloat(m) * parseFloat(getComputedStyle(document.documentElement).fontSize) * d;
    [".ui-showcase-logo-wrapper", ".ui-showcase-index-bar"].forEach(function (e) {
      var t = c.querySelector(e),
        n = "".concat(v, "px");
      t.style.minWidth = n;
    });
    var p,
      h,
      y,
      w = 0,
      b = !1,
      g = function (e) {
        o(s, e, -1), o(f, e, 1), function (e, t) {
          var n = ["filter-grayscale", "filter-none"],
            o = [].concat(n).reverse();
          e.forEach(function (e, i) {
            var c, u;
            (c = e.classList).replace.apply(c, function (e) {
              if (Array.isArray(e)) return r(e);
            }(u = i === t ? n : o) || function (e) {
              if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(u) || function (e, t) {
              if (e) {
                if ("string" == typeof e) return r(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
              }
            }(u) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }());
          });
        }(a, e), i(v) && function (e, t) {
          var n = e.parentNode,
            r = e.children,
            o = n.clientWidth / 2,
            i = r.length,
            c = Array.from(r).map(function (e) {
              return e.clientWidth;
            }).reduce(function (e, t) {
              return e + t;
            }) / i,
            u = t * c - ((t && i - t - 1 ? o - c / 2 : 0) >> 0);
          n.scrollTo({
            left: u,
            behavior: "smooth"
          });
        }(l, e);
      },
      A = function e() {
        return p = setTimeout(function () {
          b || i(v) || (w = (w + 1) % u.length, g(w), e());
        }, 5e3);
      },
      E = function () {
        var e = function () {
          b = !0, clearTimeout(p);
        };
        return c.addEventListener("mouseover", e), function () {
          return c.removeEventListener("mouseover", e);
        };
      },
      S = function () {
        var e = function () {
          b = !1, A();
        };
        return c.addEventListener("mouseleave", e), function () {
          return c.removeEventListener("mouseleave", e);
        };
      },
      L = function () {
        var e = function () {
          clearTimeout(p), A();
        };
        return document.addEventListener("resize", e), function () {
          return document.removeEventListener("resize", e);
        };
      },
      j = (h = u.map(function (e, t) {
        var n = function (e) {
          return function () {
            g(w = e);
          };
        }(t);
        return e.addEventListener("click", n), n;
      }), function () {
        h.forEach(function (e, t) {
          return u[t].removeEventListener("click", e);
        });
      }),
      x = (y = function (e) {
        return e.preventDefault();
      }, l.parentNode.addEventListener("wheel", y), function () {
        return l.parentNode.removeEventListener("wheel", y);
      }),
      U = function () {
        if (t) {
          A(), c.setAttribute("aria-live", "polite");
          var e = [E(), S(), L()];
          return function () {
            return e.forEach(function (e) {
              return e();
            });
          };
        }
        return function () {};
      }();
    return function () {
      g(0), clearTimeout(p), j(), U(), x();
    };
  };
  return t.default;
})());